module.exports = __webpack_public_path__ + "static/media/temperature-down.bf36c78a.svg";